import type { JsonValue } from "@ashare/contracts";
import { researchFieldLabel, researchScalarText } from "./research-value-format.js";

export function ResearchJsonValue({ value, field = "" }: { value: JsonValue; field?: string }): React.JSX.Element {
  if (value === null || typeof value === "boolean" || typeof value === "string" || typeof value === "number") {
    return <span>{researchScalarText(value, field)}</span>;
  }
  if (Array.isArray(value)) {
    if (value.length === 0) return <span className="research-empty">无</span>;
    return <ul className="research-value-list">{value.map((item, index) => <li key={index}><ResearchJsonValue value={item} field={field} /></li>)}</ul>;
  }
  return <dl className="research-facts">{Object.entries(value).map(([key, item]) => <div key={key}><dt>{researchFieldLabel(key)}</dt><dd><ResearchJsonValue value={item} field={key} /></dd></div>)}</dl>;
}
